import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { themes } from '@/config/theme';
import metrics from '@/services/metrics';
import { useAuth } from '@/hooks/useAuth';
import useAuthModal from '@/features/Auth/AuthModal/useAuthModal';
import { ButtonV2 as Button } from '@/components/Button';
import { Segment } from '@/components/SegmentedControl';
import ThemeVariants from '@/components/Editor/Form/fields/ThemeVariants';
import GalleryPanel from '@/features/ChartBuilder/Gallery/Panel';
import ThemePicker from '@/features/WidgetEdit/Form/ThemePicker';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CrownIcon = function CrownIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_8841_1625)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M2.00049 13H16.0005V17C16.0005 17.5523 15.5528 18 15.0005 18H3.00049C2.4482 18 2.00049 17.5523 2.00049 17V13Z",
        fill: "#C3C9D1"
      }), /*#__PURE__*/_jsx("path", {
        d: "M0.00872128 2.13694C-0.0702641 1.70613 0.40354 1.38918 0.771584 1.62662L5.54637 4.70708C5.79121 4.86504 6.11872 4.78102 6.25728 4.52469L8.56051 0.263706C8.74952 -0.0859494 9.25122 -0.0859485 9.44022 0.263707L11.7435 4.52469C11.882 4.78102 12.2095 4.86504 12.4544 4.70708L17.2291 1.62662C17.5972 1.38918 18.071 1.70613 17.992 2.13694L16.0004 13H2.00037L0.00872128 2.13694Z",
        fill: "black"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_8841_1625",
        children: /*#__PURE__*/_jsx("rect", {
          width: "18.0007",
          height: "18",
          fill: "white"
        })
      })
    })]
  }));
};

CrownIcon.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const ThemesGallery = _ref => {
  let {
    nameSpace,
    theme: defaultTheme,
    colorPallet,
    palletColorOverrides,
    previews = {},
    defaults,
    isMobileOrTablet,
    onChange,
    onClose,
    onLoadFonts,
    onMenuOpenChange,
    onOverridePalletColors
  } = _ref;
  const activeThemeId = defaultTheme || themes[0].id;
  const activeTheme = themes.find(theme => theme.id === activeThemeId);
  const {
    user
  } = useAuth();
  const {
    openModal: openAuthModal
  } = useAuthModal();
  const isAuthenticated = Boolean(user);
  return /*#__PURE__*/_jsx(GalleryPanel, _objectSpread(_objectSpread({
    title: "Themes",
    description: "Apply a professionally designed theme to your chart.",
    isMobile: isMobileOrTablet,
    className: styles.galleryPanel,
    primaryAction: /*#__PURE__*/_jsx(Button, {
      type: "button",
      size: "small",
      onClick: onClose,
      children: "Confirm"
    }),
    onClose: onClose
  }, activeTheme && {
    secondaryAction: /*#__PURE__*/_jsx(ThemeVariants, {
      nameSpace: `${nameSpace}-${activeTheme === null || activeTheme === void 0 ? void 0 : activeTheme.id}`,
      colorPallet: colorPallet || (activeTheme === null || activeTheme === void 0 ? void 0 : activeTheme.colorPallets[0].colors),
      colorPallets: (activeTheme === null || activeTheme === void 0 ? void 0 : activeTheme.colorPallets) || [],
      palletColorOverrides: palletColorOverrides,
      colorsPreviewLimit: 3,
      defaults: defaults,
      onChange: colorPallet => onChange({
        colorPallet
      }),
      onOverridePalletColors: onOverridePalletColors,
      onMenuOpenChange: onMenuOpenChange
    })
  }), {}, {
    children: /*#__PURE__*/_jsx(ThemePicker, {
      nameSpace: nameSpace,
      theme: defaultTheme,
      colorPallet: colorPallet,
      palletColorOverrides: palletColorOverrides,
      previews: previews,
      customTags: !isAuthenticated ? /*#__PURE__*/_jsx(Segment, {
        value: "brand",
        label: "Brand",
        leftIcon: /*#__PURE__*/_jsx(CrownIcon, {}),
        onClick: () => {
          metrics.sendEvent('exp_brand_themes', {}, {
            maxEventsPerSession: 1
          });
          onClose();
          openAuthModal('signup');
        }
      }) : null,
      hideFooter: true,
      hideAllTag: !isAuthenticated,
      onChange: onChange,
      onLoadFonts: onLoadFonts,
      onOverridePalletColors: onOverridePalletColors
    })
  }));
};

export default ThemesGallery;